export default function Resume() {
  return (
    <div>
      <h1>Resume</h1>
    </div>
  );
}
